"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentersDeclineText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RentersDeclineText = /** @class */ (function () {
    function RentersDeclineText() {
        this.underwritingResultCustomerWordings = [
            {
                key: "UR001",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "Please enter your postcode to continue."] })
            },
            {
                key: "UR002",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't find your address, please check your address is correct."] })
            },
            {
                key: "UR003",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure addresses in N Ireland, the Channel Islands or Isle of Man."] })
            },
            {
                key: "UR004",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure this type of property."] })
            },
            {
                key: "UR005",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can only insure properties with up to two housemates living there."] })
            },
            {
                key: "UR006",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can only insure properties with up to six adults living there."] })
            },
            {
                key: "UR007",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can only insure properties with up to 4 bedrooms."] })
            },
            {
                key: "UR008",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can only insure properties with up to 4 bathrooms."] })
            },
            {
                key: "UR009",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure this type of property."] })
            },
            {
                key: "UR010",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we currently can't accept more than one claim."] })
            },
            {
                key: "UR011",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR012",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure properties that have been previously flooded."] })
            },
            {
                key: "UR013",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR014",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR015",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR016",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR017",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "Please enter a valid email address."] })
            },
            {
                key: "UR018",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR019",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR020",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR021",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR022",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR023",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR025",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
            {
                key: "UR027",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure this type of property."] })
            },
            {
                key: "UR028",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...you can't insure more than 10 items."] })
            },
            {
                key: "UR029",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "The item you just added has taken the total value of your specified items above the contents limit you have chosen.", (0, jsx_runtime_1.jsx)("br", {}), "Please review your contents limit to ensure this covers the total value of all of your possessions."] })
            },
            {
                key: "UR030",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "Flow provides content insurance for tenants only.", (0, jsx_runtime_1.jsx)("br", {}), "If you are a homeowner, and you want to cover your personal possessions within the home, it's best to get a traditional home insurance quote instead."] })
            },
            {
                key: "UR031",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure items which have a combined value of more than \u00A320,000."] })
            },
            {
                key: "UR032",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Good news - your contents are already covered under Flow insurance subscription.", ' ', (0, jsx_runtime_1.jsx)("br", {}), "To view your cover details or make a change, ", (0, jsx_runtime_1.jsx)("a", { href: "/dashboard", className: "a-bold", children: "go to your account" }), "."] })
            },
            {
                key: "UR033",
                value: (0, jsx_runtime_1.jsxs)("p", { children: ["Sorry...", (0, jsx_runtime_1.jsx)("br", {}), "...we can't insure you."] })
            },
        ];
    }
    ;
    return RentersDeclineText;
}());
exports.RentersDeclineText = RentersDeclineText;
//# sourceMappingURL=RentersDeclineText.js.map